import React from 'react';
import apple from '../../assets/images/logos/other/apple-logo.png';
import playStore from '../../assets/images/logos/other/google-play-logo.png';
import login from '../../assets/images/contacts.png';
import facebook from '../../assets/images/logos/other/facebook-logo.png';
import instagram from '../../assets/images/logos/other/instagram-logo.png';
import twitter from '../../assets/images/logos/other/twitter-logo.png';
import appGallery from '../../assets/images/logos/other/app-gallery-logo.png';
import { connect } from "react-redux";
import { AppState } from '../../../app/store/rootReducers';
import FooterColumn from './FooterColumn';
import Consumers from '../../../constants/Consumers';
import './scss/index.scss';


const mapStateToProps = (state: AppState) => ({
  footer: state.pageShell.data.footer,
  section: state.section.section,
  language: state.language.language,
});

type Props = ReturnType<typeof mapStateToProps>;

const Footer: React.FC<Props> = (props: any) => {
  const renderColumns = (columns: object[]) => {
    return columns.map((column: any, index: number) => {
      return <FooterColumn key={column.id} column={column}/>;
    });
  };

  const { footer, section } = props;
  const labels = require(`../../../translations/${props.language}`);

  return (
    <footer>
      <div className="container-fluid footer-container">
        <div className="row">
          <div className="col col-12 col-xl-3 float-md-start logo-column">
            <a href="/">
              <span className="footer-logo yettel-bold-font">Yettel.</span>
            </a>
          </div>
          <div className="col col-12 col-xl-9 float-md-start content-column">
            <div className="row">
              <div className="col col-12 col-xl-3">
                <div className="footer-head">{footer.consumer.call_us}</div>
                <div className="footer-call-us"><a href="tel:0639000">063 9000</a></div>
                <div className="footer-moj-telenor"> Yettel app</div>
                <div className="footer-actions">
                  <a href="https://itunes.apple.com/us/app/moj-telenor/id1004559997?mt=8">
                    <img alt={'apple'} className="footer-icon" src={apple}/>
                    <span className="footer-icon-text yettel-light-font">App Store</span>
                  </a>
                </div>
                <div className="footer-actions">
                  <a href="https://play.google.com/store/apps/details?id=rs.telenor.mymenu">
                    <img alt={'playStore'} className="footer-icon" src={playStore}/>
                    <span className="footer-icon-text yettel-light-font">Play Store</span>
                  </a>
                </div>
                <div className="footer-actions">
                  <a href="https://appgallery.huawei.com/#/app/C101431453?channelId=EURSMKT20200525PI&detailType=0">
                    <img alt={'appGallery'} className="footer-icon" src={appGallery}/>
                    <span className="footer-icon-text yettel-light-font">App Gallery</span>
                  </a>
                </div>
                {
                  section === Consumers.PRIVATE_CONSUMER &&
                  <div className="footer-actions">
                    <a href="https://www.yettel.rs/nalog/app/">
                      <img alt={'login'} className="footer-icon" src={login}/>
                      <span className="footer-icon-text yettel-light-font">{labels.account}</span>
                    </a>
                  </div>
                }
              </div>
              {
                Boolean(Object.keys(props.footer.consumer).length > 0) &&
                renderColumns(props.footer.consumer.content)
              }
            </div>
          </div>
        </div>
        <div className="row">
          <div className={' col col-12'}>
            <div className="footer-bottom">
              <div className="d-inline-block float-end footer-social-container">
                <a href="https://twitter.com/YettelSrbija_tw">
                  <img alt={'twitter'} className="footer-img" src={twitter}/>
                </a>
                <a href="https://www.facebook.com/YettelSrbija/">
                  <img alt={'facebook'} className="footer-img" src={facebook}/>
                </a>
                <a href="https://www.instagram.com/yettelsrbija/">
                  <img alt={'instagram'} className="footer-img" src={instagram}/>
                </a>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>

          <div className="col footer-copy">
            <span>&copy; {new Date().getFullYear()} Yettel {labels.serbia}</span>
            <span className="float-end">
              <a
                href="https://www.yettel.rs/sr/o-yettelu/obavestenje-o-privatnosti/obavestenje-o-kolacicima/"
                className="text-decoration-none text-white"
              >
                {labels.privacyPolicy}
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default connect(mapStateToProps)(Footer);
